import type { LastMonthRevenueDTO } from "../models/lastMonthRevenueDto";
import type { LastMonthRevenueEntity } from "../../domain/entities/LastMonthRevenueEntity";

export function lastMonthRevenueDtoToEntity(
  dto: LastMonthRevenueDTO
): LastMonthRevenueEntity {
  return {
    monthLabel: dto.monthLabel ?? "",
    status: dto.status ?? "medium",
    revenue: Number(dto.revenue) || 0,
    ebitda: Number(dto.ebitda) || 0,
    ebitdaMargin: dto.ebitdaMargin != null ? Number(dto.ebitdaMargin) : null,
    momPercent: dto.momPercent != null ? Number(dto.momPercent) : null,
    avgRevenue: Number(dto.avgRevenue) || 0,
    barMonths: (dto.barMonths ?? []).map((m) => ({
      year: Number(m.year),
      month: Number(m.month),
      label: String(m.label ?? ""),
      revenue: Number(m.revenue) || 0,
    })),
  };
}
